import { FC, ReactNode } from 'react';

import { SecondaryFormTemplate } from '../shared/components/SecondaryFormTemplate';
import { DlpOrderFormContentSkeleton } from './dlpOrderFormContent.skeleton';

type DlpOrderFormProps = Readonly<{
  children: ReactNode;
  tabId: string;
  isLoading: boolean;
  sidePanel: ReactNode;
}>;

export const DlpOrderForm: FC<DlpOrderFormProps> = ({ children, isLoading, sidePanel }) => {
  return (
    <SecondaryFormTemplate sidePanel={sidePanel} bigSidePanel={false}>
      {isLoading ? <DlpOrderFormContentSkeleton /> : children}
    </SecondaryFormTemplate>
  );
};

DlpOrderForm.displayName = 'DlpOrderForm';
